import { Component, createApp, h } from 'vue';
type Config = {
    zIndex?: number;
    single?: boolean;
};
type Option = {
    params?: any;
    config?: Config;
};
let container: HTMLElement | null = null;
const map = new WeakMap();
const ID = '__myDialogContainer';
export function showDialog<T extends Component>(dialog: T, option?: Option) {
    const { params, config } = option || {};
    // 创建一个容器
    if (!container) {
        container = document.createElement('div');
        container.setAttribute('id', ID);
        container.style.position = 'relative';
        // 将新元素插入到body中
        document.body.appendChild(container);
    }
    function init() {
        // 先关闭之前存在的弹窗
        if (config?.single) {
            map.get(dialog)?.();
        }
        // 创建一个元素来承载弹窗
        const box = document.createElement('div');
        box.style.position = 'absolute';
        box.style.zIndex = String(config?.zIndex || 1);
        container!.style.zIndex = String(config?.zIndex || 100);
        container?.appendChild(box);
        // 创建应用程序实例
        const app = createApp(
            h(dialog, {
                ...params,
                onClosed: close,
            }),
        );
        function close() {
            app?.unmount();
            box?.remove();
            map.delete(dialog);
        }
        map.set(dialog, close);
        // 将应用程序实例挂载到新元素上
        // @ts-ignore
        const instance = app.mount(box) as InstanceType<T>;

        return instance;
    }
    return init();
}
